<div
  class="header h-[55px] flex justify-start items-center pl-[50px] mb-[10px] bg-[#F1F3F5]"
>
  <p class="!m-0">{{ projectName }} - Request for Proposal (RFP)</p>
  <p
    class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
  >
    Commercial Evaluation Criteria
  </p>
</div>
<div class="!pl-[50px] !mb-[15px]">
  <div class=" text-[1rem] text-[#343A40] font-semibold">
    Instructions for Commercial Evaluation Weightage Allocation
  </div>
  <p calss="text-[14px] pl-[50px]">Assign a percentage to every field, ensuring the total equals 100%. No field should be left blank, and incomplete distributions will not be accepted.</p>
</div>
<div class="!pl-[50px] !mb-[15px] text-[1rem] text-[#343A40] font-semibold">
  Enter Weightage
</div>
<div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
  <div class="p-0">
    <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Price Competitiveness</mat-label>
        <input
          matInput
          type="number"
          [formControl]="priceCompetitivenessControl"
          placeholder="Enter Weightage"
        />
        <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1px]" matSuffix [style.opacity]="priceCompetitivenessControl.value ? '1' : '0'">percent</mat-icon>

      </mat-form-field>
      <mat-error
        *ngIf="
          priceCompetitivenessControl.invalid &&
          priceCompetitivenessControl.touched
        "
        class="relative top-[-15px]"
      >
        Weight for Price Competitiveness is required.
      </mat-error>
    </div>
  </div>

  <div class="p-0">
    <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Payment Terms</mat-label>
        <input
          matInput
          type="number"
          [formControl]="paymentTermsControl"
          placeholder="Enter Weightage"
        />
        <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1.5px]" matSuffix [style.opacity]="paymentTermsControl.value ? '1' : '0'">percent</mat-icon>

      </mat-form-field>
      <mat-error
        *ngIf="paymentTermsControl.invalid && paymentTermsControl.touched"
        class="relative top-[-15px]"
      >
        Weight for Payment Terms is required.
      </mat-error>
    </div>
  </div>

  <div class="p-0">
    <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Financial Stability</mat-label>
        <input
          matInput
          type="number"
          [formControl]="financialStabilityControl"
          placeholder="Enter Weightage"
        />
        <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1px]" matSuffix [style.opacity]="financialStabilityControl.value ? '1' : '0'">percent</mat-icon>

      </mat-form-field>
      <mat-error
        *ngIf="
          financialStabilityControl.invalid && financialStabilityControl.touched
        "
        class="relative top-[-15px]"
      >
        Weight for Financial Stability is required.
      </mat-error>
    </div>
  </div>

  <div class="p-0">
    <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Commercial Risk Allocation</mat-label>
        <input
          matInput
          type="number"
          [formControl]="commercialRiskAllocationControl"
          placeholder="Enter Weightage"
        />
        <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  !bg-gray-200 !mr-[1.5px]" matSuffix [style.opacity]="commercialRiskAllocationControl.value ? '1' : '0'">percent</mat-icon>

      </mat-form-field>
      <mat-error
        *ngIf="
          commercialRiskAllocationControl.invalid &&
          commercialRiskAllocationControl.touched
        "
        class="relative top-[-15px]"
      >
        Weight for Commercial Risk Allocation is required.
      </mat-error>
    </div>
  </div>
  <p [ngClass]="{ 'text-[#EE4B2B]': totalWeight > 100,'text-[#505255]': totalWeight < 100, 'text-green-500': totalWeight === 100 }">
    Total Weightage: {{ totalWeight }} %
  </p>
</div>

<!-- Back and next Buttons -->
<div
  class="relative bottom-0 right-0 !pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button (click)="moveToPreviousStep()" type="button" class="back-btn">
      Back
    </button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
      (click)="moveToNextStep()"
    >
      Next
    </button>
  </div>
</div>
